const Gymnastics = (props: any) => (
  <svg
    data-aid="svgGymnastics"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3485 12.4139C12.8445 12.4139 12.3611 12.6137 12.0047 12.9692C11.6483 13.3247 11.448 13.8069 11.448 14.3098C11.448 14.8126 11.6483 15.2948 12.0047 15.6503C12.3611 16.0058 12.8445 16.2056 13.3485 16.2056C14.4032 16.2056 15.2489 15.3619 15.2489 14.3098C15.2489 13.8069 15.0487 13.3247 14.6923 12.9692C14.3359 12.6137 13.8525 12.4139 13.3485 12.4139ZM2.74379 1.02063C2.36868 0.919567 2 1.2025 2 1.59143C2 1.82499 2.13736 2.03665 2.35051 2.13154L10.0769 5.57126L9.69231 11.2176L9.06232 14.3098L9.6036 19.4901C9.61708 19.6191 9.67443 19.7395 9.76604 19.8313C10.1285 20.1942 10.7475 19.9252 10.7303 19.4123L10.5829 15.0064L11.077 13.5816C11.3993 12.652 12.2742 12.0289 13.257 12.0289H13.2752L16.1695 12.1474L19.811 12.9083C19.9916 12.946 20.1786 12.8851 20.3024 12.7482C20.5567 12.4672 20.4351 12.0171 20.0741 11.9026L17.202 10.9921L14.3077 10.2219L13.8189 5.57126L21.5214 2.50983C21.748 2.41973 21.8969 2.20026 21.8969 1.95608C21.8969 1.57235 21.5399 1.28869 21.1666 1.37587L12.0047 3.51584L2.74379 1.02063Z"
      fill="currentColor"
    />
    <path
      d="M2.76923 21.2298C2.76923 20.8045 3.11363 20.4597 3.53846 20.4597H21.2308C21.6556 20.4597 22 20.8045 22 21.2298C22 21.6552 21.6556 22 21.2308 22H3.53846C3.11363 22 2.76923 21.6552 2.76923 21.2298Z"
      fill="currentColor"
    />
  </svg>
);

export default Gymnastics;
